import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Button, Loader } from '@mantine/core';
import { makePostRequest } from '../services/httpHelper';
import ErrorHandler from '../services/ErrorHandler';
import { isErrorObject } from '../utils/utils';

const OnboardingDashboardPage: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [message, setMessage] = useState<string>('');
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const onboardingData = {
            tracking_id: queryParams.get('merchantId'),
            merchant_id_in_Paypal: queryParams.get('merchantIdInPayPal'),
            permissions_granted: queryParams.get('permissionsGranted') === 'true',
            account_status: queryParams.get('accountStatus'),
            consent_status: queryParams.get('consentStatus') === 'true',
            product_intend_id: queryParams.get('productIntentId'),
            is_email_confirmed: queryParams.get('isEmailConfirmed') === 'true',
            return_message: queryParams.get('returnMessage'),
        };

        const sendToBackend = async () => {
            const res = await makePostRequest('paypal-signup-return-url', onboardingData);
            if (isErrorObject(res)) {
                const errorMessage = ErrorHandler(res);
                setError(errorMessage);
            } else {
                setMessage(onboardingData.return_message || 'Onboarding process completed successfully.');
            }
            setIsLoading(false);
        };

        sendToBackend();
    }, [location.search]);

    return (
        <div style={{ textAlign: 'center', padding: '50px' }}>
            {isLoading && <Loader />}
            {error && <p className="error">{error}</p>}
            {!isLoading && !error && (
                <>
                    <h1>Onboarding Status</h1>
                    <p>{message}</p>
                    <Button onClick={() => navigate('/')}>Continue</Button>
                </>
            )}
        </div>
    );
};

export default OnboardingDashboardPage;